export const theme = {
  primaryHeaderColor: '#333',
  primaryTextColor: '#525252',
  secondaryTextColor: '#fff',
  primaryColor: '#d7aa8d',
  secondaryColor: '#929fab',
  secondaryColorRGB: '94, 101, 107',
  textFont: "'Roboto', Helvetica, sans-serif",
  headerFont: "'Montserrat', sans-serif",
}
